import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, FormControlLabel, RadioGroup,
} from '@material-ui/core';
import CustomRadio from '../common/CustomRadio';
import CustomCheckbox from '../common/CustomCheckbox';
import {
  setSearchTarget,
  setAreaConfig,
  setQuickSearchFlg,
} from '../../actions/CompanyAction';
import { SEARCH_TARGET, DUNS_NOT_USED_FLG } from '../../../common/const';
import styles from './CompanySearchCondComponent.module.css';

class CompanySearchCondComponent extends Component {
  render() {
    const {
      quickSearchFlg,
      quickSearchCondition,
      areaList,
      setSearchTargetAct,
      setAreaConfigAct,
      setQuickSearchFlgAct,
      userInfo,
    } = this.props;
    // 検索対象(DUNS未使用フラグによって検索対象にDUNSを表示するか切り替える)
    const targetList = (userInfo.duns_not_used_flag === DUNS_NOT_USED_FLG.ON ? [
      { id: SEARCH_TARGET.COMPANY_NAME, name: '企業名（部分一致）' },
      { id: SEARCH_TARGET.COMPANY_NAME_PERFECT, name: '企業名（完全一致）' },
      { id: SEARCH_TARGET.KIGYO_CODE, name: 'TSRコード（完全一致）' },
      { id: SEARCH_TARGET.CORPORATE_NUMBER, name: '法人番号（完全一致）' },
    ] : [
      { id: SEARCH_TARGET.COMPANY_NAME, name: '企業名（部分一致）' },
      { id: SEARCH_TARGET.COMPANY_NAME_PERFECT, name: '企業名（完全一致）' },
      { id: SEARCH_TARGET.DUNS, name: 'D&B D-U-N-S® Number（完全一致）' },
      { id: SEARCH_TARGET.KIGYO_CODE, name: 'TSRコード（完全一致）' },
      { id: SEARCH_TARGET.CORPORATE_NUMBER, name: '法人番号（完全一致）' },
    ]);

    return (quickSearchFlg && (
      <>
        <div
          className={`${styles.detailcondition} `}
          onClick={() => { setQuickSearchFlgAct(false); }}
        />
        <Box className={`${styles.parts} `}>
          <Paper elevation={2} className={`${styles.sectionBox}`}>
            {/* 検索対象 */}
            <Box className={`${styles.targetCheckbox}`}>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>検索対象</Typography>
              <RadioGroup className={`${styles.targetCheckboxBlock}`}>
                {targetList && targetList.map((target, i) => (
                  <FormControlLabel
                    key={i}
                    label={target.name}
                    control={<CustomRadio />}
                    checked={quickSearchCondition.search_target === target.id}
                    onChange={() => setSearchTargetAct(target.id)}
                    className={`${styles.serchCheckbox}`}
                  />
                ))}
              </RadioGroup>
            </Box>

            {/* 本社所在地 */}
            {Array.isArray(areaList) && (
              <Box className={`${styles.areaCheckbox}`}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>本社所在地</Typography>
                <Box className={`${styles.areaCheckboxBlock}`}>
                  {areaList.map((area, i) => (
                    <Box className={`${styles.serchCheckbox}`} key={i}>
                      <FormControlLabel
                        control={(
                          <CustomCheckbox
                            checked={quickSearchCondition.area_config.indexOf(area.area_code) >= 0}
                            onClick={() => setAreaConfigAct(area.area_code)}
                          />
                        )}
                        label={area.area_name}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Paper>
        </Box>
      </>
    ));
  }
}

export default connect(
  (state) => ({
    // 検索詳細設定の表示フラグ
    quickSearchFlg: state.company.quickSearchFlg,
    // QuickSearch(詳細設定)の検索条件
    quickSearchCondition: state.company.quickSearchCondition,
    // 地域リスト
    areaList: state.company.areaList,
    // ユーザー情報
    userInfo: state.common.userInfo,
  }),
  (dispatch) => ({
    // 検索条件詳細（検索対象）の選択値設定
    setSearchTargetAct: (str) => dispatch(setSearchTarget(str)),
    // 検索条件詳細（地域設定）の選択値設定
    setAreaConfigAct: (str) => dispatch(setAreaConfig(str)),
    // 検索条件詳細の表示フラグ設定
    setQuickSearchFlgAct: (obj) => dispatch(setQuickSearchFlg(obj)),
  }),
)(CompanySearchCondComponent);
